import { createFileRoute } from "@tanstack/react-router";
import KontaktStockholm from "@/pages/KontaktStockholm";
import { buildBreadcrumbSchema, getBreadcrumbTrail, buildOfficeSchema, buildPageSchema, buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/kontakt-stockholm")({
  head: () =>
    buildSeoHead(publicPageSeo.kontaktStockholm, [
      buildPageSchema(publicPageSeo.kontaktStockholm, "ContactPage"),
      buildOfficeSchema("stockholm"),
      buildBreadcrumbSchema(getBreadcrumbTrail("/kontakt-stockholm") ?? []),
    ]),
  component: KontaktStockholm,
});
